module.exports = __webpack_public_path__ + "img/galery-inge-v6-3.fef8ca2a.jpg";